<!--


<div class="main-content d-flex flex-column">

  <div class="h-100">
    <div class="row h-100">
      <div class="container-fluid h-100">
        <div class="row" style="background-color: darkolivegreen;">
          <div class="col-12  h-25">25%</div>
        </div>
        <div class="row h-100" style="background-color: cadetblue;">
          <div class="col-12 h-75">75%</div>
        </div>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="flex-grow-1" style="background-color: darkolivegreen;">25%</div>
  <div class="flex-grow-1" style="background-color: cadetblue;">75%</div>
</div> -->
<div [ngClass]="isExpanded ? 'main-wrapper menu-expanded' : 'main-wrapper'">
  @if (isExpanded) {
    <nav class="navbar navbar-vertical navbar-expand-lg navbar-dark bg-black px-0" role="navigation">
      <div class="container-fluid">
        <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbar-collapse">
          <span class="navbar-toggler-icon"></span>
        </button>
        <a class="navbar-brand home" [routerLink]="" (click)="navigateHome()">
          <img class="logo" src="../../assets/img/pin-iot.svg"/>
        </a>
        @if (userIsAdmin) {
          <div class="pl-5">
            <mat-form-field
              class="company-dropdown"
              appearance="fill"
              floatLabel="always"
            >

              <input
                type="text"
                matInput
                [formControl]="companyCtrl"
                [matAutocomplete]="companyAuto"
              />

              <!-- arrow on the right -->
              <button
                mat-icon-button
                matSuffix
                tabindex="-1"
                (click)="companyAuto.isOpen ? companyAuto.closePanel() : companyAuto.openPanel()"
              >
                <mat-icon>arrow_drop_down</mat-icon>
              </button>

              <mat-autocomplete
                #companyAuto="matAutocomplete"
                class="company-dropdown-panel"
                [displayWith]="displayCompany"
                (optionSelected)="selectCompany($event.option.value)"
              >
                @for (company of filteredCompanies | async; track company.id) {
                  <mat-option class="dropdown-item" [value]="company">
                    {{ company.name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }
        <div class="collapse navbar-collapse mt-md-2" id="navbar-collapse">
          <ul class="navbar-nav" id="sidebar-nav">
            @if (showInventry || showContainerRegistry || showIntegrationReport || showContainerAvailabilityReport || showTracking) {
              <li class="nav-item">
                <a href="#containers"  class="nav-link" data-bs-toggle="collapse" [attr.aria-expanded]="this.activeSideBarItem === 'Containers' ? 'true' : 'false'" aria-controls="containers">
                  <span class="svg-icon text-primary me-2 relative-top--2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Containers</title><path d="M448,341.37V170.61A32,32,0,0,0,432.11,143l-152-88.46a47.94,47.94,0,0,0-48.24,0L79.89,143A32,32,0,0,0,64,170.61V341.37A32,32,0,0,0,79.89,369l152,88.46a48,48,0,0,0,48.24,0l152-88.46A32,32,0,0,0,448,341.37Z" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><polyline points="69 153.99 256 263.99 443 153.99" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><line x1="256" y1="463.99" x2="256" y2="263.99" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/></svg>
                  </span>
                  Containers
                  <i class="fas fa-chevron-down fa-xs collapse-icon ms-auto"></i>
                </a>
                <div [className]="this.activeSideBarItem === 'Containers' ? 'collapse show' : 'collapse'" id="containers" data-bs-parent="#sidebar-nav">
                  <ul class="nav nav-sm flex-column pb-2">
                    @if (showInventry) {
                      <li class="nav-item">
                        <a [routerLink]="['/container-inventory']" class="nav-link" [routerLinkActive]="['active']">
                          Container Inventory
                        </a>
                      </li>
                    }
                    @if (showContainerAvailabilityReport) {
                      <li class="nav-item">
                        <a [routerLink]="['/container-availability']" class="nav-link" [routerLinkActive]="['active']">
                          Container Availability
                        </a>
                      </li>
                    }
                    @if (showContainerRegistry) {
                      <li class="nav-item">
                        <a [routerLink]="['/container-register']" class="nav-link" [routerLinkActive]="['active']">
                          Container Register
                        </a>
                      </li>
                    }
                    @if (showDamageReport) {
                      <li class="nav-item">
                        <a [routerLink]="['/damage-report']" class="nav-link" [routerLinkActive]="['active']">
                          Damage
                        </a>
                      </li>
                    }
                    @if (showDamageReport) {
                      <li class="nav-item">
                        <a [routerLink]="['/damage-history-report']" class="nav-link" [routerLinkActive]="['active']">
                          Damage History
                        </a>
                      </li>
                    }
                    @if (showTracking) {
                      <li class="nav-item">
                        <a href="/Tracking" class="nav-link">
                          Tracking
                        </a>
                      </li>
                    }                    
                  </ul>
                </div>
              </li>
            }
            @if (showServiceFrequency || showKpi || showIntegrationReport) {
              <li class="nav-item">
                <a href="#customers"  class="nav-link" data-bs-toggle="collapse" [attr.aria-expanded]="this.activeSideBarItem === 'Customers' ? 'true' : 'false'" aria-controls="customers">
                  <span class="svg-icon text-primary me-2 relative-top--1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Customers</title><path d="M344,144c-3.92,52.87-44,96-88,96s-84.15-43.12-88-96c-4-55,35-96,88-96S348,90,344,144Z" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><path d="M256,304c-87,0-175.3,48-191.64,138.6C62.39,453.52,68.57,464,80,464H432c11.44,0,17.62-10.48,15.65-21.4C431.3,352,343,304,256,304Z" style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:32px"/></svg>              </span>
                    Customers
                    <i class="fas fa-chevron-down fa-xs collapse-icon ms-auto"></i>
                  </a>
                  <div [className]="this.activeSideBarItem === 'Customers' ? 'collapse show' : 'collapse'" id="customers" data-bs-parent="#sidebar-nav">
                    <ul class="nav nav-sm flex-column pb-2">
                      @if (showServiceFrequency) {
                        <li class="nav-item">
                          <a [routerLink]="['/service-frequency']" class="nav-link" [routerLinkActive]="['active']">
                            Service Frequency
                          </a>
                        </li>
                      }
                      @if (showIntegrationReport) {
                        <li class="nav-item">
                          <a class="nav-link" [routerLink]="['/integration-report']" [routerLinkActive]="['active']">
                            Contracts
                          </a>
                        </li>
                      }
                      @if (showCollectionsReport) {
                        <li class="nav-item">
                          <a class="nav-link" [routerLink]="['/customer-collections']" [routerLinkActive]="['active']">
                            Collections
                          </a>
                        </li>
                      }
                    </ul>
                  </div>
                </li>
              }
              @if (showLive || showActive) {
                <li class="nav-item">
                  <a href="#operations" class="nav-link" data-bs-toggle="collapse" [attr.aria-expanded]="this.activeSideBarItem === 'Operations' ? 'true' : 'false'" aria-controls="operations">
                    <span class="svg-icon text-primary me-2 relative-top--2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Opertations</title><polyline points="352 144 464 144 464 256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><path d="M48,368,169.37,246.63a32,32,0,0,1,45.26,0l50.74,50.74a32,32,0,0,0,45.26,0L448,160" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/></svg>
                    </span>
                    Operations
                    <i class="fas fa-chevron-down fa-xs collapse-icon ms-auto"></i>
                  </a>
                  <div [className]="this.activeSideBarItem === 'Operations' ? 'collapse show' : 'collapse'" id="operations" data-bs-parent="#sidebar-nav">
                    <ul class="nav nav-sm flex-column pb-2">
                      @if (showLive) {
                        <li class="nav-item">
                          <a [routerLink]="['/live']" class="nav-link" [routerLinkActive]="['active']">
                            Live Operations
                          </a>
                        </li>
                      }
                      @if (showActive) {
                        <li class="nav-item">
                          <a [routerLink]="['/active']" class="nav-link" [routerLinkActive]="['active']">
                            Active Operations
                          </a>
                        </li>
                      }
                      @if (showKpi) {
                        <li class="nav-item">
                          <a [routerLink]="['/report-builder']" class="nav-link" [routerLinkActive]="['active']">
                            KPI
                          </a>
                        </li>
                      }
                      @if (showTippingActivityReport) {
                        <li class="nav-item">
                          <a [routerLink]="['/activity-report']" class="nav-link" [routerLinkActive]="['active']">
                            Activity Report
                          </a>
                        </li>
                      }
                    </ul>
                  </div>
                </li>
              }
              @if (userIsAdmin) {
                <li class="nav-item">
                  <a href="#admin"  class="nav-link" data-bs-toggle="collapse" [attr.aria-expanded]="this.activeSideBarItem === 'Admin' ? 'true' : 'false'" aria-controls="admin">
                    <span class="svg-icon text-primary me-2 relative-top--1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Admin Menu</title><path d="M456.7,242.27l-26.08-4.2a8,8,0,0,1-6.6-6.82c-.5-3.2-1-6.41-1.7-9.51a8.08,8.08,0,0,1,3.9-8.62l23.09-12.82a8.05,8.05,0,0,0,3.9-9.92l-4-11a7.94,7.94,0,0,0-9.4-5l-25.89,5a8,8,0,0,1-8.59-4.11q-2.25-4.2-4.8-8.41a8.16,8.16,0,0,1,.7-9.52l17.29-19.94a8,8,0,0,0,.3-10.62l-7.49-9a7.88,7.88,0,0,0-10.5-1.51l-22.69,13.63a8,8,0,0,1-9.39-.9c-2.4-2.11-4.9-4.21-7.4-6.22a8,8,0,0,1-2.5-9.11l9.4-24.75A8,8,0,0,0,365,78.77l-10.2-5.91a8,8,0,0,0-10.39,2.21L327.77,95.91a7.15,7.15,0,0,1-8.5,2.5s-5.6-2.3-9.8-3.71A8,8,0,0,1,304,87l.4-26.45a8.07,8.07,0,0,0-6.6-8.42l-11.59-2a8.07,8.07,0,0,0-9.1,5.61l-8.6,25.05a8,8,0,0,1-7.79,5.41h-9.8a8.07,8.07,0,0,1-7.79-5.41l-8.6-25.05a8.07,8.07,0,0,0-9.1-5.61l-11.59,2a8.07,8.07,0,0,0-6.6,8.42l.4,26.45a8,8,0,0,1-5.49,7.71c-2.3.9-7.3,2.81-9.7,3.71-2.8,1-6.1.2-8.8-2.91L167.14,75.17A8,8,0,0,0,156.75,73l-10.2,5.91A7.94,7.94,0,0,0,143.25,89l9.4,24.75a8.06,8.06,0,0,1-2.5,9.11c-2.5,2-5,4.11-7.4,6.22a8,8,0,0,1-9.39.9L111,116.14a8,8,0,0,0-10.5,1.51l-7.49,9a8,8,0,0,0,.3,10.62l17.29,19.94a8,8,0,0,1,.7,9.52q-2.55,4-4.8,8.41a8.11,8.11,0,0,1-8.59,4.11l-25.89-5a8,8,0,0,0-9.4,5l-4,11a8.05,8.05,0,0,0,3.9,9.92L85.58,213a7.94,7.94,0,0,1,3.9,8.62c-.6,3.2-1.2,6.31-1.7,9.51a8.08,8.08,0,0,1-6.6,6.82l-26.08,4.2a8.09,8.09,0,0,0-7.1,7.92v11.72a7.86,7.86,0,0,0,7.1,7.92l26.08,4.2a8,8,0,0,1,6.6,6.82c.5,3.2,1,6.41,1.7,9.51a8.08,8.08,0,0,1-3.9,8.62L62.49,311.7a8.05,8.05,0,0,0-3.9,9.92l4,11a7.94,7.94,0,0,0,9.4,5l25.89-5a8,8,0,0,1,8.59,4.11q2.25,4.2,4.8,8.41a8.16,8.16,0,0,1-.7,9.52L93.28,374.62a8,8,0,0,0-.3,10.62l7.49,9a7.88,7.88,0,0,0,10.5,1.51l22.69-13.63a8,8,0,0,1,9.39.9c2.4,2.11,4.9,4.21,7.4,6.22a8,8,0,0,1,2.5,9.11l-9.4,24.75a8,8,0,0,0,3.3,10.12l10.2,5.91a8,8,0,0,0,10.39-2.21l16.79-20.64c2.1-2.6,5.5-3.7,8.2-2.6,3.4,1.4,5.7,2.2,9.9,3.61a8,8,0,0,1,5.49,7.71l-.4,26.45a8.07,8.07,0,0,0,6.6,8.42l11.59,2a8.07,8.07,0,0,0,9.1-5.61l8.6-25a8,8,0,0,1,7.79-5.41h9.8a8.07,8.07,0,0,1,7.79,5.41l8.6,25a8.07,8.07,0,0,0,9.1,5.61l11.59-2a8.07,8.07,0,0,0,6.6-8.42l-.4-26.45a8,8,0,0,1,5.49-7.71c4.2-1.41,7-2.51,9.6-3.51s5.8-1,8.3,2.1l17,20.94A8,8,0,0,0,355,439l10.2-5.91a7.93,7.93,0,0,0,3.3-10.12l-9.4-24.75a8.08,8.08,0,0,1,2.5-9.12c2.5-2,5-4.1,7.4-6.21a8,8,0,0,1,9.39-.9L401,395.66a8,8,0,0,0,10.5-1.51l7.49-9a8,8,0,0,0-.3-10.62l-17.29-19.94a8,8,0,0,1-.7-9.52q2.55-4.05,4.8-8.41a8.11,8.11,0,0,1,8.59-4.11l25.89,5a8,8,0,0,0,9.4-5l4-11a8.05,8.05,0,0,0-3.9-9.92l-23.09-12.82a7.94,7.94,0,0,1-3.9-8.62c.6-3.2,1.2-6.31,1.7-9.51a8.08,8.08,0,0,1,6.6-6.82l26.08-4.2a8.09,8.09,0,0,0,7.1-7.92V250A8.25,8.25,0,0,0,456.7,242.27ZM256,112A143.82,143.82,0,0,1,395.38,220.12,16,16,0,0,1,379.85,240l-105.24,0a16,16,0,0,1-13.91-8.09l-52.1-91.71a16,16,0,0,1,9.85-23.39A146.94,146.94,0,0,1,256,112ZM112,256a144,144,0,0,1,43.65-103.41,16,16,0,0,1,25.17,3.47L233.06,248a16,16,0,0,1,0,15.87l-52.67,91.7a16,16,0,0,1-25.18,3.36A143.94,143.94,0,0,1,112,256ZM256,400a146.9,146.9,0,0,1-38.19-4.95,16,16,0,0,1-9.76-23.44l52.58-91.55a16,16,0,0,1,13.88-8H379.9a16,16,0,0,1,15.52,19.88A143.84,143.84,0,0,1,256,400Z"/></svg>              </span>
                      Admin Menu
                      <i class="fas fa-chevron-down fa-xs collapse-icon ms-auto"></i>
                    </a>
                    <div [className]="this.activeSideBarItem === 'Admin' ? 'collapse show' : 'collapse'" id="admin" data-bs-parent="#sidebar-nav">
                      <ul class="nav nav-sm flex-column pb-2">
                        @if (userIsAdmin) {
                          <li class="nav-item">
                            <a [routerLink]="['/admin-alerts']" class="nav-link" [routerLinkActive]="['active']">
                              Alerts
                            </a>
                          </li>
                        }
                        @if (userIsAdmin) {
                          <li class="nav-item">
                            <a (click)="makeDemoCustomer()" class="nav-link">
                              Make Demo Customer
                            </a>
                          </li>
                        }
                        @if (userIsAdmin) {
                          <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/devices']" [routerLinkActive]="['active']">
                              Yabby Devices
                            </a>
                          </li>
                        }
                        @if (userIsAdmin) {
                          <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/container-availability-report']" [routerLinkActive]="['active']">
                              Container Availability Report
                            </a>
                          </li>
                        }
                        @if (showIntegrationReport) {
                          <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/integration-report', {showAdminOptions: true}]" [routerLinkActive]="['active']">
                              Contracts (Admin)
                            </a>
                          </li>
                        }
                        @if (userIsAdmin) {
                          <li class="nav-item">
                            <a class="nav-link" href="/Home/AdminHome">
                              Admin System
                            </a>
                          </li>
                        }
                      </ul>
                    </div>
                  </li>
                }
                @if (userIsFinance) {
                  <li class="nav-item">
                    <a href="#finance"  class="nav-link" data-bs-toggle="collapse" [attr.aria-expanded]="this.activeSideBarItem === 'Finance' ? 'true' : 'false'" aria-controls="finance">
                      <span class="svg-icon text-primary me-2 relative-top--1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bank2" viewBox="0 0 16 16">
                          <path d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916zM12.375 6v7h-1.25V6zm-2.5 0v7h-1.25V6zm-2.5 0v7h-1.25V6zm-2.5 0v7h-1.25V6zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2M.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1z"/>
                        </svg>
                      </span>
                      Finance Menu
                      <i class="fas fa-chevron-down fa-xs collapse-icon ms-auto"></i>
                    </a>
                    <div [className]="this.activeSideBarItem === 'Finance' ? 'collapse show' : 'collapse'" id="finance" data-bs-parent="#sidebar-nav">
                      <ul class="nav nav-sm flex-column pb-2">
                        <li class="nav-item">
                          <a class="nav-link" [routerLink]="['/billing-details']" [routerLinkActive]="['active']">
                            Billing Details
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" [routerLink]="['/billing-summary']" [routerLinkActive]="['active']">
                            Billing Summary
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                }
                <li class="nav-item">
                  @if (isLoggedIn) {
                    <a href="#logout"  class="nav-link" data-bs-toggle="collapse" (click)="logout()" aria-controls="logout">
                      <span class="svg-icon text-primary me-2 relative-top--1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Logout</title><path d="M176,176V136a40,40,0,0,1,40-40H424a40,40,0,0,1,40,40V376a40,40,0,0,1-40,40H216a40,40,0,0,1-40-40V336" style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"></path><polyline points="272 336 352 256 272 176" style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"></polyline><line x1="48" y1="256" x2="336" y2="256" style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"></line></svg>              </span>
                        Logout
                      </a>
                    }
                  </li>
                </ul>
                <a class="btn btn-dark-lt btn-sm mt-auto d-none d-lg-block" style="transform: rotateY(180deg);" (click)="toggleSidebar()" data-sidebar="lg">
                  <span class="svg-icon text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Collapse</title><polyline points="400 352 464 288 400 224" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"></polyline><path d="M448,288H154C95.24,288,48,238.67,48,180V160" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"></path></svg>
                  </span>
                </a>
              </div>
            </div>
          </nav>
        }

        @if (!isExpanded) {
          <nav class="navbar navbar-vertical navbar-vertical-sm fixed-left navbar-expand-lg navbar-dark bg-black px-0">
            <div class="container-fluid">
              <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbar-collapse">
                <span class="navbar-toggler-icon"></span>
              </button>
              <a class="navbar-brand home" [routerLink]="" (click)="navigateHome()">
                <img class="logo-sm" src="../../assets/img/pin-iot.svg"/>
              </a>
              <div class="collapse navbar-collapse mt-md-3" id="navbar-collapse">
                <ul class="navbar-nav">
                  @if (showInventry || showContainerRegistry || showIntegrationReport || showContainerAvailabilityReport || showTracking) {
                    <li class="nav-item dropdown dropend" (mouseenter)="onMenuHover($event)" (mouseleave)="onMenuLeave($event)">
                      <a href="#" class="nav-link dropdown-toggle " data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="svg-icon text-primary me-2 me-md-0 relative-top--2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Containers</title><path d="M448,341.37V170.61A32,32,0,0,0,432.11,143l-152-88.46a47.94,47.94,0,0,0-48.24,0L79.89,143A32,32,0,0,0,64,170.61V341.37A32,32,0,0,0,79.89,369l152,88.46a48,48,0,0,0,48.24,0l152-88.46A32,32,0,0,0,448,341.37Z" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><polyline points="69 153.99 256 263.99 443 153.99" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><line x1="256" y1="463.99" x2="256" y2="263.99" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/></svg>
                        </span>
                        <span class="d-md-none">Containers</span>
                      </a>
                      <ul class="dropdown-menu">
                        <li class="dropdown-header d-none d-md-block">
                          <span class="text-uppercase-xs fw-bolder">Containers</span>
                        </li>
                        @if (showInventry) {
                          <li>
                            <a [routerLink]="['/container-inventory']" class="dropdown-item">
                              Container Inventory
                            </a>
                          </li>
                        }
                        @if (showContainerAvailabilityReport) {
                          <li>
                            <a [routerLink]="['/container-availability']" class="dropdown-item">
                              Container Availability
                            </a>
                          </li>
                        }
                        @if (showContainerRegistry) {
                          <li>
                            <a [routerLink]="['/container-register']" class="dropdown-item">
                              Container Register
                            </a>
                          </li>
                        }
                        @if (showDamageReport) {
                          <li>
                            <a [routerLink]="['/damage-report']" class="dropdown-item">
                              Damage
                            </a>
                          </li>
                        }
                        @if (showDamageReport) {
                          <li>
                            <a [routerLink]="['/damage-history-report']" class="dropdown-item">
                              Damage History
                            </a>
                          </li>
                        }
                        @if (showTracking) {
                          <li>
                            <a href="/Tracking" class="dropdown-item">
                              Tracking
                            </a>
                          </li>
                        }                        
                      </ul>
                    </li>
                  }
                  @if (showServiceFrequency || showKpi || showDamageReport) {
                    <li class="nav-item dropdown dropend" (mouseenter)="onMenuHover($event)" (mouseleave)="onMenuLeave($event)">
                      <a href="#" class="nav-link dropdown-toggle " data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
                        <span class="svg-icon text-primary me-2 me-md-0 relative-top--2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Customers</title><path d="M344,144c-3.92,52.87-44,96-88,96s-84.15-43.12-88-96c-4-55,35-96,88-96S348,90,344,144Z" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><path d="M256,304c-87,0-175.3,48-191.64,138.6C62.39,453.52,68.57,464,80,464H432c11.44,0,17.62-10.48,15.65-21.4C431.3,352,343,304,256,304Z" style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:32px"/></svg>
                        </span>
                        <span class="d-md-none">Customers</span>
                      </a>
                      <ul class="dropdown-menu">
                        <li class="dropdown-header d-none d-md-block">
                          <span class="text-uppercase-xs fw-bolder">Customers</span>
                        </li>
                        @if (showServiceFrequency) {
                          <li>
                            <a [routerLink]="['/service-frequency']" class="dropdown-item">
                              Service Frequency
                            </a>
                          </li>
                        }
                        @if (showIntegrationReport) {
                          <li>
                            <a [routerLink]="['/integration-report']" class="dropdown-item">
                              Contracts
                            </a>
                          </li>
                        }
                        @if (showCollectionsReport) {
                          <li>
                            <a [routerLink]="['/customer-collections']" class="dropdown-item">
                              Collections
                            </a>
                          </li>
                        }
                      </ul>
                    </li>
                  }
                  @if (showLive || showActive) {
                    <li class="nav-item dropdown dropend" (mouseenter)="onMenuHover($event)" (mouseleave)="onMenuLeave($event)">
                      <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="svg-icon text-primary me-2 me-md-0 relative-top--2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Operations</title><polyline points="352 144 464 144 464 256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/><path d="M48,368,169.37,246.63a32,32,0,0,1,45.26,0l50.74,50.74a32,32,0,0,0,45.26,0L448,160" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/></svg>
                        </span>
                        <span class="d-md-none">Operations</span>
                      </a>
                      <ul class="dropdown-menu">
                        <li class="dropdown-header d-none d-md-block">
                          <span class="text-uppercase-xs fw-bolder">Operations</span>
                        </li>
                        @if (showLive) {
                          <li>
                            <a [routerLink]="['/live']" class="dropdown-item">
                              Live Operations
                            </a>
                          </li>
                        }
                        @if (showActive) {
                          <li>
                            <a [routerLink]="['/active']" class="dropdown-item">
                              Active Operations
                            </a>
                          </li>
                        }
                        @if (showKpi) {
                          <li>
                            <a [routerLink]="['/report-builder']" class="dropdown-item">
                              KPI
                            </a>
                          </li>
                        }
                        @if (showTippingActivityReport) {
                          <li>
                            <a [routerLink]="['/activity-report']" class="dropdown-item">
                              Activity Report
                            </a>
                          </li>
                        }
                      </ul>
                    </li>
                  }
                  @if (userIsAdmin) {
                    <li class="nav-item dropdown dropend" (mouseenter)="onMenuHover($event)" (mouseleave)="onMenuLeave($event)">
                      <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
                        <span class="svg-icon text-primary me-2 me-md-0 relative-top--2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Admin Menu</title><path d="M456.7,242.27l-26.08-4.2a8,8,0,0,1-6.6-6.82c-.5-3.2-1-6.41-1.7-9.51a8.08,8.08,0,0,1,3.9-8.62l23.09-12.82a8.05,8.05,0,0,0,3.9-9.92l-4-11a7.94,7.94,0,0,0-9.4-5l-25.89,5a8,8,0,0,1-8.59-4.11q-2.25-4.2-4.8-8.41a8.16,8.16,0,0,1,.7-9.52l17.29-19.94a8,8,0,0,0,.3-10.62l-7.49-9a7.88,7.88,0,0,0-10.5-1.51l-22.69,13.63a8,8,0,0,1-9.39-.9c-2.4-2.11-4.9-4.21-7.4-6.22a8,8,0,0,1-2.5-9.11l9.4-24.75A8,8,0,0,0,365,78.77l-10.2-5.91a8,8,0,0,0-10.39,2.21L327.77,95.91a7.15,7.15,0,0,1-8.5,2.5s-5.6-2.3-9.8-3.71A8,8,0,0,1,304,87l.4-26.45a8.07,8.07,0,0,0-6.6-8.42l-11.59-2a8.07,8.07,0,0,0-9.1,5.61l-8.6,25.05a8,8,0,0,1-7.79,5.41h-9.8a8.07,8.07,0,0,1-7.79-5.41l-8.6-25.05a8.07,8.07,0,0,0-9.1-5.61l-11.59,2a8.07,8.07,0,0,0-6.6,8.42l.4,26.45a8,8,0,0,1-5.49,7.71c-2.3.9-7.3,2.81-9.7,3.71-2.8,1-6.1.2-8.8-2.91L167.14,75.17A8,8,0,0,0,156.75,73l-10.2,5.91A7.94,7.94,0,0,0,143.25,89l9.4,24.75a8.06,8.06,0,0,1-2.5,9.11c-2.5,2-5,4.11-7.4,6.22a8,8,0,0,1-9.39.9L111,116.14a8,8,0,0,0-10.5,1.51l-7.49,9a8,8,0,0,0,.3,10.62l17.29,19.94a8,8,0,0,1,.7,9.52q-2.55,4-4.8,8.41a8.11,8.11,0,0,1-8.59,4.11l-25.89-5a8,8,0,0,0-9.4,5l-4,11a8.05,8.05,0,0,0,3.9,9.92L85.58,213a7.94,7.94,0,0,1,3.9,8.62c-.6,3.2-1.2,6.31-1.7,9.51a8.08,8.08,0,0,1-6.6,6.82l-26.08,4.2a8.09,8.09,0,0,0-7.1,7.92v11.72a7.86,7.86,0,0,0,7.1,7.92l26.08,4.2a8,8,0,0,1,6.6,6.82c.5,3.2,1,6.41,1.7,9.51a8.08,8.08,0,0,1-3.9,8.62L62.49,311.7a8.05,8.05,0,0,0-3.9,9.92l4,11a7.94,7.94,0,0,0,9.4,5l25.89-5a8,8,0,0,1,8.59,4.11q2.25,4.2,4.8,8.41a8.16,8.16,0,0,1-.7,9.52L93.28,374.62a8,8,0,0,0-.3,10.62l7.49,9a7.88,7.88,0,0,0,10.5,1.51l22.69-13.63a8,8,0,0,1,9.39.9c2.4,2.11,4.9,4.21,7.4,6.22a8,8,0,0,1,2.5,9.11l-9.4,24.75a8,8,0,0,0,3.3,10.12l10.2,5.91a8,8,0,0,0,10.39-2.21l16.79-20.64c2.1-2.6,5.5-3.7,8.2-2.6,3.4,1.4,5.7,2.2,9.9,3.61a8,8,0,0,1,5.49,7.71l-.4,26.45a8.07,8.07,0,0,0,6.6,8.42l11.59,2a8.07,8.07,0,0,0,9.1-5.61l8.6-25a8,8,0,0,1,7.79-5.41h9.8a8.07,8.07,0,0,1,7.79,5.41l8.6,25a8.07,8.07,0,0,0,9.1,5.61l11.59-2a8.07,8.07,0,0,0,6.6-8.42l-.4-26.45a8,8,0,0,1,5.49-7.71c4.2-1.41,7-2.51,9.6-3.51s5.8-1,8.3,2.1l17,20.94A8,8,0,0,0,355,439l10.2-5.91a7.93,7.93,0,0,0,3.3-10.12l-9.4-24.75a8.08,8.08,0,0,1,2.5-9.12c2.5-2,5-4.1,7.4-6.21a8,8,0,0,1,9.39-.9L401,395.66a8,8,0,0,0,10.5-1.51l7.49-9a8,8,0,0,0-.3-10.62l-17.29-19.94a8,8,0,0,1-.7-9.52q2.55-4.05,4.8-8.41a8.11,8.11,0,0,1,8.59-4.11l25.89,5a8,8,0,0,0,9.4-5l4-11a8.05,8.05,0,0,0-3.9-9.92l-23.09-12.82a7.94,7.94,0,0,1-3.9-8.62c.6-3.2,1.2-6.31,1.7-9.51a8.08,8.08,0,0,1,6.6-6.82l26.08-4.2a8.09,8.09,0,0,0,7.1-7.92V250A8.25,8.25,0,0,0,456.7,242.27ZM256,112A143.82,143.82,0,0,1,395.38,220.12,16,16,0,0,1,379.85,240l-105.24,0a16,16,0,0,1-13.91-8.09l-52.1-91.71a16,16,0,0,1,9.85-23.39A146.94,146.94,0,0,1,256,112ZM112,256a144,144,0,0,1,43.65-103.41,16,16,0,0,1,25.17,3.47L233.06,248a16,16,0,0,1,0,15.87l-52.67,91.7a16,16,0,0,1-25.18,3.36A143.94,143.94,0,0,1,112,256ZM256,400a146.9,146.9,0,0,1-38.19-4.95,16,16,0,0,1-9.76-23.44l52.58-91.55a16,16,0,0,1,13.88-8H379.9a16,16,0,0,1,15.52,19.88A143.84,143.84,0,0,1,256,400Z"/></svg>
                        </span>
                        <span class="d-md-none">Admin Menu</span>
                      </a>
                      <ul class="dropdown-menu">
                        <li class="dropdown-header d-none d-md-block">
                          <span class="text-uppercase-xs fw-bolder">Admin Menu</span>
                        </li>
                        <li>
                          <a [routerLink]="['/admin-alerts']" class="dropdown-item">
                            Alerts
                          </a>
                        </li>
                        <li>
                          <a (click)="makeDemoCustomer()" class="dropdown-item">
                            Make Demo Customer
                          </a>
                        </li>
                        <li>
                          <a [routerLink]="['/devices']" class="dropdown-item">
                            Yabby Devices
                          </a>
                        </li>
                        <li>
                          <a [routerLink]="['/container-availability-report']" class="dropdown-item">
                            Container Availability Report
                          </a>
                        </li>
                        @if (showIntegrationReport) {
                          <li>
                            <a [routerLink]="['/integration-report', {showAdminOptions: true}]" class="dropdown-item">
                              Contracts (Admin)
                            </a>
                          </li>
                        }
                        @if (showIntegrationReport) {
                          <li>
                            <a href="/Home/AdminHome" class="dropdown-item">
                              Admin System
                            </a>
                          </li>
                        }
                      </ul>
                    </li>
                  }
                  @if (userIsFinance) {
                    <li class="nav-item dropdown dropend" (mouseenter)="onMenuHover($event)" (mouseleave)="onMenuLeave($event)">
                      <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
                        <span class="svg-icon text-primary me-2 me-md-0 relative-top--2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bank2" viewBox="0 0 16 16">
                            <path d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916zM12.375 6v7h-1.25V6zm-2.5 0v7h-1.25V6zm-2.5 0v7h-1.25V6zm-2.5 0v7h-1.25V6zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2M.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1z"/>
                          </svg>
                        </span>
                        <span class="d-md-none">Finance Menu</span>
                      </a>
                      <ul class="dropdown-menu">
                        <li class="dropdown-header d-none d-md-block">
                          <span class="text-uppercase-xs fw-bolder">Finance Menu</span>
                        </li>
                        <li>
                          <a [routerLink]="['/billing-details']" class="dropdown-item">
                            Billing Details
                          </a>
                        </li>
                        <li>
                          <a [routerLink]="['/billing-summary']" class="dropdown-item">
                            Billing Summary
                          </a>
                        </li>
                      </ul>
                    </li>
                  }
                </ul>
                <a class="btn btn-dark-lt btn-sm mt-auto d-none" (click)="logout()" data-sidebar="sm" style="transform: rotateY(180deg);">
                  <span class="svg-icon text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Logout</title><path d="M176,176V136a40,40,0,0,1,40-40H424a40,40,0,0,1,40,40V376a40,40,0,0,1-40,40H216a40,40,0,0,1-40-40V336" style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"></path><polyline points="272 336 352 256 272 176" style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"></polyline><line x1="48" y1="256" x2="336" y2="256" style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"></line></svg>
                  </span>
                </a>
                <a class="btn btn-dark-lt btn-sm mt-auto d-none d-lg-block" (click)="toggleSidebar()" data-sidebar="sm">
                  <span class="svg-icon text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Expand</title><polyline points="400 352 464 288 400 224" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"></polyline><path d="M448,288H154C95.24,288,48,238.67,48,180V160" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"></path></svg>
                  </span>
                </a>
              </div>
            </div>
          </nav>
        }

        <div class="h-100 main-content d-flex flex-column">
          <nav class="navbar navbar-expand-lg navbar-dark bg-black d-none d-lg-block px-0">
            <div class="container-fluid">
              <h1>
                @if (showBackButton) {
                  <span _ngcontent-ng-cli-universal-c856488149="" class="svg-icon text-primary me-2 me-md-0 relative-top--2" (click)="goBack()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Back</title><path d="M48,256c0,114.87,93.13,208,208,208s208-93.13,208-208S370.87,48,256,48,48,141.13,48,256Zm212.65-91.36a16,16,0,0,1,.09,22.63L208.42,240H342a16,16,0,0,1,0,32H208.42l52.32,52.73A16,16,0,1,1,238,347.27l-79.39-80a16,16,0,0,1,0-22.54l79.39-80A16,16,0,0,1,260.65,164.64Z"/></svg>
                  </span>
                }
                {{ pageTitle }}
              </h1>
              @if (loading) {
                <img class="throbber" src="../../assets/img/loader.svg" />
              }
            </div>
          </nav>
          <div class="flex-grow-1 router-content">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
